export default __webpack_public_path__ + "static/tech-alexa-b3d4c51793c5849253afc256a060469c.png";